import { useSearchParams } from "react-router-dom";
import ProgressStepper from "../partials/ProgressStepper";
import StepOne from "../steps/StepOne";
import StepTwo from "../steps/StepTwo";
import StepThree from "../steps/StepThree";
import StepFour from "../steps/StepFour";
import StepFive from "../steps/StepFive";

const RenderData = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeStep = parseInt(searchParams.get("step") || "1");
  const handleStepChange = (newStep) => {
    if (newStep > 5 || newStep <= 0) return;
    setSearchParams({ step: newStep.toString() });
  };

  let stepContent;
  switch (activeStep) {
    case 1:
      stepContent = <StepOne />;
      break;
    case 2:
      stepContent = <StepTwo />;
      break;
    case 3:
      stepContent = <StepThree />;
      break;
    case 4:
      stepContent = <StepFour />;
      break;
    case 5:
      stepContent = <StepFive />;
      break;
  }
  return (
    <div className="create-assessment-container h-full w-full p-2 xl:p-4">
      <div className="card h-full w-full">
        <ProgressStepper
          activeStep={activeStep}
          setActiveStep={handleStepChange}
        />
        {stepContent}
      </div>
    </div>
  );
};

export default RenderData;
